<template>
    <div class="modal-window modb200">
        <header class="modal-header">
            <div class="tit">{{ $i18nUtil.trans("title.PrevQrtUnit.001","이전 소속 조회") }}</div>
            <button @click="$emit('close')" class="btn_close">닫기</button>
        </header>
        
        <div class="modal-content">
            <div class="info-txt">{{ $i18nUtil.trans("message.PrevQrtUnit.001","이전 소속을 선택해주세요. 과거 수행했던 OKR을 조회하실 수 있습니다.") }}</div>

            <ul class="list-table">
                <li>
                    <dl>
                        <dt>{{ $i18nUtil.trans("message.PrevQrtUnit.002","수행 기간") }}</dt>
                        <dd>
                            <div class="dropdown ty2 relative" v-if="prevQrtList.length > 0">
                                <v-menu offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-bind="attrs" v-on="on">{{selectPrevQrt.QRT_TOP_MSG}}</v-btn>
                                    </template>
                                    <div class="dropdown-list" style="height: 100px;">
                                        <div class="dropdown-list-item" v-for="(prevQrt, index) in prevQrtList" :key="'qrt'+index">
                                            <div class="tit">
                                                <button type="button" :class="{ active: prevQrt.QRT_CD == selectQrtCd }" @click="getQrtUnitList(prevQrt)">{{prevQrt.QRT_TOP_MSG}}</button>
                                            </div>
                                        </div>
                                    </div>
                                </v-menu>
                            </div>
                        </dd>
                    </dl>
                </li>
                <li>
                    <dl>
                        <dt>{{ $i18nUtil.trans("message.PrevQrtUnit.003","이전 소속") }}</dt>
                        <dd>
                            <div class="dropdown ty2 wide relative" v-if="qrtUnitList.length > 0">
                                <v-menu offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-bind="attrs" v-on="on">{{selectQrtUnit.DEPT_NAME}}</v-btn>
                                    </template>
                                    <div class="dropdown-list" style="height: 100px;">
                                        <div class="dropdown-list-item" v-for="(qrtUnit, index) in qrtUnitList" :key="'unit'+index">
                                            <div class="tit">
                                                <button type="button" class="" @click="setQrtUnit(qrtUnit)">{{qrtUnit.DEPT_NAME}}</button>
                                            </div>
                                        </div>
                                    </div>
                                </v-menu>
                            </div>
                        </dd>
                    </dl>
                </li>
            </ul>   

        </div>

        <footer class="modal-footer">
            <button type="button" class="btn_ty1" @click="serachQrtInfo">{{ $i18nUtil.trans("message.PrevQrtUnit.004","조회") }}</button>
        </footer>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
export default {
    data() {
        return { 
            prevQrtList : [],
            qrtUnitList : [],
            selectPrevQrt : null,
            selectQrtUnit : null,
            selectPrevQrtCd : null
        };
    },
    mounted() {
        /* 이전분기 목록 조회 */
        this.getPrevQrtList();
    },
    watch : {
        selectPrevQrtCd: function() {
            this.getQrtUnitList();
        }
    },
    methods: {
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        ...mapMutations("okrQrt", ["setQrtUnitAndList"]),
        /* 이전분기 목록 조회 */
        getPrevQrtList() {
            let obj = this;
            let reqData = {
                url: "/api/org/okr/getPrevQrtList",
                method: "post",
                params: {
                    locale: obj.$i18nUtil.getLanguage()
                }
            };
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function(res) {
                if(res !== null) {
                    if(res.result !== null) {
                        obj.prevQrtList = res.result;
                        obj.selectPrevQrt = obj.prevQrtList[0];
                        obj.selectPrevQrtCd = obj.prevQrtList[0].QRT_CD;
                        console.log("################# getPrevQrtList");
                        console.log(obj.prevQrtList);
                        console.log(obj.selectPrevQrt);
                        console.log("#################");
                    }
                }
            })
            .catch(function(err) {
                console.log(err);
            })
        },
        /*  분기별 해당하는 팀/파트유닛 목록 조회 */
        getQrtUnitList(selectQrt) {
            let obj = this;
            let selectQrtCd = null;
            if(selectQrt !== undefined) {
                obj.selectPrevQrt = selectQrt;
                selectQrtCd = selectQrt.QRT_CD;
            } else {
                selectQrtCd = obj.selectPrevQrt.QRT_CD;
            }
            let reqData = {
                url: "/api/org/okr/getQrtUnitList",
                method: "post",
                params: {
                    selectQrtCd : selectQrtCd,
                    locale : obj.$i18nUtil.getLanguage()
                }
            };
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function(res) {
                if(res !== null) {
                    if(res.result !== null) {
                        obj.qrtUnitList = res.result;
                        obj.selectQrtUnit = obj.qrtUnitList[0];
                        console.log("################# getQrtUnitList");
                        console.log(obj.qrtUnitList);
                        console.log("#################");
                    } else {
                        obj.qrtUnitList = [];
                    }
                }
            })
            .catch(function(err) {
                console.log(err);
            })
        },
        setQrtUnit(qrtUnit) {
            this.selectQrtUnit = qrtUnit;
        },
        serachQrtInfo() {
            //this.$emit("changeUserPrevUnit", this.selectQrtCd + "^" + this.selectQrtUnit);
            // this.deleteMenuHtmlToRedis();
            this.setQrtUnitAndList({selectPrevQrt : this.selectPrevQrt, selectQrtUnit : this.selectQrtUnit});
            this.$emit('close');
        },
        deleteMenuHtmlToRedis() {
            let obj = this;
            let reqData  = {
                url :  "/api/org/okr/deleteMenuHtmlToRedis",
                method : "post",
            };
            obj.COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function(res) {
                if (res != null) {
                console.log("deleteMenuHtmlToRedis result ::"+res.result);
                }
            })
            .catch(function (err) {
                console.log(err);
            })
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/main/modal/PrevQrtUnit.vue